module.exports = __webpack_public_path__ + "img/Equatorial Guinea.d671e87d.gif";